var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 540 312",
    style: {
      enableBackground: "new 0 0 540 312"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5F5F5;}\n\t.st1{fill:#F0F0F0;}\n\t.st2{fill:#E1E1E1;}\n\t.st3{fill:#E7E7E7;}\n\t.st4{fill:none;stroke:#E1E1E1;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#FCC1BB;}\n\t.st6{fill:#090A0A;}\n\t.st7{fill:#007CFF;}\n\t.st8{opacity:0.2;enable-background:new    ;}\n\t.st9{fill:#25084F;}\n\t.st10{fill:#19A396;}\n\t.st11{fill:#FFFFFF;}\n\t.st12{fill:#090B0C;}\n\t.st13{fill:#FFD1CF;}\n\t.st14{fill:#1A2E35;}\n\t.st15{fill:#199384;}\n\t.st16{opacity:0.4;enable-background:new    ;}\n\t.st17{fill:#24BCB0;}\n\t.st18{fill:#19406C;}\n\t.st19{fill:#E0B1AF;}\n\t.st20{fill:#FCB373;}\n\t.st21{fill:#0A0C0C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 168.96,
    y: 96.01,
    className: "st0",
    width: 6.34,
    height: 173.42
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 194.02,
    y: 118.03,
    className: "st0",
    width: 6.34,
    height: 151.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 218.84,
    y: 140.05,
    className: "st0",
    width: 6.34,
    height: 129.38
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 243.67,
    y: 125.37,
    className: "st0",
    width: 6.34,
    height: 144.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 268.5,
    y: 118.03,
    className: "st0",
    width: 6.34,
    height: 151.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 293.33,
    y: 103.35,
    className: "st0",
    width: 6.34,
    height: 166.08
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 318.16,
    y: 110.69,
    className: "st0",
    width: 6.34,
    height: 158.74
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 342.98,
    y: 103.35,
    className: "st0",
    width: 6.34,
    height: 166.08
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 367.81,
    y: 88.67,
    className: "st0",
    width: 6.34,
    height: 180.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 392.64,
    y: 74,
    className: "st0",
    width: 6.34,
    height: 195.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 417.47,
    y: 59.32,
    className: "st0",
    width: 6.34,
    height: 210.11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.01,129.73c-0.36,0-0.71-0.14-0.99-0.4L167.97,77.6c-0.56-0.54-0.57-1.44-0.02-2 c0.54-0.56,1.44-0.57,2-0.02l52.2,50.9l73.52-53.62c0.59-0.43,1.41-0.34,1.89,0.21l24.07,27.22l99.63-57.08 c0.68-0.39,1.54-0.15,1.93,0.52c0.39,0.68,0.15,1.54-0.52,1.93L322.03,103.3c-0.58,0.33-1.32,0.21-1.76-0.29l-23.98-27.12 l-73.45,53.57C222.6,129.64,222.3,129.73,222.01,129.73z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "216,268.35 169.7,85.75 172.01,76.63 169.6,76.63 169.6,24.47 163.38,24.47 163.38,76.63  160.97,76.63 163.29,85.75 116.98,268.35 123.39,268.35 163.38,110.64 163.38,269.31 169.6,269.31 169.6,110.64 209.59,268.35  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 54.5549 220.3525)",
    className: "st3",
    cx: 166.49,
    cy: 75.71,
    rx: 35.85,
    ry: 35.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 166.49,
    cy: 75.71,
    r: 30.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 166.49,
    cy: 75.71,
    r: 23.96
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -16.2995 69.4764)",
    className: "st0",
    cx: 166.49,
    cy: 75.71,
    rx: 19.64,
    ry: 19.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 54.555 220.3525)",
    className: "st3",
    cx: 166.49,
    cy: 75.71,
    rx: 13.63,
    ry: 13.63
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -16.2995 69.4763)",
    className: "st0",
    cx: 166.49,
    cy: 75.71,
    rx: 9.78,
    ry: 9.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M170.93,75.71c0,2.45-1.99,4.44-4.44,4.44s-4.44-1.99-4.44-4.44c0-2.45,1.99-4.44,4.44-4.44 S170.93,73.26,170.93,75.71z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "120.48,46.14 121.45,52.63 114.71,54.9 121.45,58.44 128.17,56.07 127,49.68  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 166.49,
    y1: 75.71,
    x2: 118.25,
    y2: 50.99
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.88,35.44c0-4.59,3.72-8.3,8.3-8.3c0.83,0,1.63,0.13,2.38,0.35c-0.12-0.83-0.19-1.68-0.19-2.55 c0-9.71,7.87-17.58,17.58-17.58c1.11,0,2.19,0.11,3.24,0.3c2.7-4.42,7.56-7.38,13.12-7.38c8.42,0,15.25,6.76,15.37,15.15 c0.09,0,0.17-0.01,0.26-0.01c7.82,0,14.16,6.34,14.16,14.16s-6.34,14.16-14.16,14.16h-52.01l0.01-0.01 C236.48,43.61,232.88,39.95,232.88,35.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M380.62,30.88c0-2.21,1.79-4,4-4c0.4,0,0.78,0.06,1.15,0.17c-0.06-0.4-0.09-0.81-0.09-1.23 c0-4.68,3.79-8.47,8.47-8.47c0.53,0,1.05,0.05,1.56,0.15c1.3-2.13,3.64-3.56,6.32-3.56c4.06,0,7.35,3.26,7.41,7.3 c0.04,0,0.08-0.01,0.12-0.01c3.77,0,6.82,3.06,6.82,6.82c0,3.77-3.06,6.82-6.82,6.82H384.5l0.01-0.01 C382.35,34.82,380.62,33.05,380.62,30.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.78,35.86c0-1.49,1.2-2.69,2.69-2.69c0.27,0,0.53,0.04,0.77,0.11c-0.04-0.27-0.06-0.55-0.06-0.83 c0-3.15,2.55-5.69,5.69-5.69c0.36,0,0.71,0.03,1.05,0.1c0.88-1.43,2.45-2.39,4.25-2.39c2.73,0,4.94,2.19,4.98,4.91 c0.03,0,0.05,0,0.08,0c2.53,0,4.59,2.05,4.59,4.59s-2.05,4.59-4.59,4.59h-16.85l0,0C124.94,38.51,123.78,37.32,123.78,35.86z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__359_",
    className: "st0",
    cx: 270,
    cy: 301.06,
    rx: 182.58,
    ry: 10.66
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__130_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M164.9,121.51l6.46-3.69c0,0,2.48-3.84,3.23-4.01c0.75-0.17,8.94,0,8.94,0s-1.24,5.3-1.37,6.35 c-0.12,1.05-7.95,0-7.95,0l-6.33,3.78L164.9,121.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M104.73,293.27l-6.76-1.35c-0.25,0-0.46,0.17-0.52,0.42l-1.82,6.76c-0.1,0.48,0.21,0.96,0.69,1.06 c0.06,0.01,0.13,0.02,0.2,0.02c2.39-0.04,4.13-0.19,7.13-0.19c1.85,0,7.42,0.19,9.97,0.19s2.88-2.52,1.84-2.75 c-4.69-1.02-8.21-2.44-9.71-3.78C105.47,293.4,105.11,293.26,104.73,293.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M187.47,293.07h-7.38c-0.25,0-0.46,0.17-0.52,0.42l-1.2,5.41c-0.1,0.48,0.21,0.96,0.69,1.06 c0.06,0.01,0.13,0.02,0.2,0.02c2.39-0.04,4.13-0.19,7.13-0.19c1.85,0,7.42,0.19,9.97,0.19c2.55,0,2.88-2.52,1.84-2.75 c-4.69-1.02-8.21-2.44-9.71-3.78C188.21,293.2,187.85,293.07,187.47,293.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M117.76,168.69l31.27-7.93c7.09,15.48,33.11,79.04,39.41,131.93l-10.59,2.68c0,0-18.73-77.99-34.45-100.74 c0,0-0.84,34.62-2.55,39.66c-1.4,4.14-33.58,59.58-33.58,59.58l-10.45-1.19c0,0,26.22-56.59,27.82-63.64 c1.09-4.81-3.69-40.08-3.69-40.08c-0.85-3.15-2.1-16.17-2.1-16.17S117.91,169.34,117.76,168.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M143.41,194.63c2.32,3.35,4.64,7.69,6.92,12.64c-2.16-12.19-8.87-23.99-8.87-23.99L143.41,194.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M117.76,168.69l31.27-7.93c7.09,15.48,33.11,79.04,39.41,131.93l-10.59,2.68c0,0-18.73-77.99-34.45-100.74 c0,0-0.84,34.62-2.55,39.66c-1.4,4.14-33.58,59.58-33.58,59.58l-10.45-1.19c0,0,26.22-56.59,27.82-63.64 c1.09-4.81-3.69-40.08-3.69-40.08c-0.85-3.15-2.1-16.17-2.1-16.17S117.91,169.34,117.76,168.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M172.11,122.04c0,0-14.26,9.62-18.01,10.13c-1.5,0.21-4.59-0.3-7.78-0.98c-4.84-1.04-9.89-2.49-9.89-2.49 l-0.63-4.77l-0.67-5.1c1.13-0.38,15.88,5.69,18.08,6.55c2.2,0.87,16.45-7.57,16.45-7.57L172.11,122.04z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.03,166.49 128.95,170.11 118.85,172.8 117.91,169.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.95,162.45 144.82,165.88 130.07,169.81 129.15,166.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.63,164.33 145.94,165.59 145.07,162.17 149.38,161.08  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.31,
    y: 163.25,
    transform: "matrix(-0.9693 0.2458 -0.2458 -0.9693 313.0409 291.7555)",
    className: "st11",
    width: 6.01,
    height: 4.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M149.37,161.07l-31.47,7.99c-1.53-4.15-3.1-8.33-4.62-12.41c-1.12-2.99-2.22-5.91-3.3-8.75 c-0.27-0.73-0.55-1.44-0.82-2.15c-0.32-0.85-0.64-1.69-0.95-2.5c-0.7-1.84-1.37-3.61-2.02-5.3c-0.6-1.58-1.19-3.1-1.73-4.53 c-0.28-0.73-0.56-1.45-0.82-2.15c-0.56-1.45-1.07-2.81-1.55-4.05l33.04-8.38C146.04,137.84,149.37,161.07,149.37,161.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M114.09,126.41c3.4,1.62,9.68-1.25,9.68-1.25s2.08-2.3,0.84-3.32c-2.53,0.33-2.36-0.5-3.28-1.79 c-0.53-0.75-0.86-1.68-1.07-2.67c-0.12-0.52-0.2-1.06-0.26-1.6l-9.9-3.55C112.36,115.87,115.85,122.75,114.09,126.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M113.12,115.48c1.78,4.76,6.18,4.89,8.21,4.58c-0.53-0.75-0.86-1.68-1.07-2.67L113.12,115.48z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M126.04,97.47c0,0,2.58,7.82-1.15,11.63c-3.73,3.81-6.27-11.13-6.27-11.13L126.04,97.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M113.61,117.58c2.57,2.62,6.07,2.82,8.84,1.4c1.78-0.91,3.26-2.5,3.99-4.56c0.1-0.27,0.18-0.55,0.25-0.84 c1.26-5.26,0.47-13.95-5.26-16.28c-4.08-1.69-8.76,0.24-10.45,4.32c-0.49,1.16-0.69,2.42-0.59,3.68 C110.72,111.14,110.65,114.59,113.61,117.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M114.68,98l0.56,1.08c-1.9,0.72-1.41,2.94-0.98,3.94c0.93,2.13-0.14,5.55-1.74,6.96c0,0-0.1-0.94-0.88-0.68 c-0.78,0.26-0.33,5.14,1.32,7.4c0,0-2.44-2-4-7.07c-1.44-4.69-1.78-8.64-0.89-10.52L114.68,98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M107.83,110.09c0.65,1.32,1.79,2.34,3.19,2.82c1.85,0.62,2.88-1.01,2.45-2.81c-0.39-1.6-1.82-3.9-3.72-3.72 C107.84,106.55,107.05,108.46,107.83,110.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M122.02,100c0,0,6.56-3.2,5.81-6.4c-0.75-3.2-2.7,0.45-2.7,0.45s0.89-2.43-0.85-2.77 c-1.73-0.34-1.16,1.11-2.09,2.04c-0.93,0.93-10.07-0.42-13.02,1.4s-0.69,8.15-0.69,8.15S114.01,96.87,122.02,100z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "125.01,125.17 124.46,130.05 134.63,151.72 133.62,154.59 130.29,153.05 123.05,130.96  117.71,127.34 121.59,125.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "114.32,121.83 121.05,124.62 121.33,120.06 126.29,121.28 126.71,128.23 121.94,126.27  119.95,130.72 111.46,125.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "114.32,121.83 121.05,124.62 121.33,120.06 126.29,121.28 126.71,128.23 121.94,126.27  119.95,130.72 111.46,125.05  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M108.21,143.24c-0.7-1.84-1.37-3.61-2.02-5.3c-0.6-1.58-1.19-3.1-1.73-4.53c-0.28-0.73-0.56-1.45-0.82-2.15 c0.99-0.46,3.34-0.19,4.01,0.97C110.1,136.48,108.21,143.24,108.21,143.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M120.01,148.02c0,0-0.73,5.39-6.73,8.62c-1.12-2.99-2.22-5.91-3.3-8.75c-0.27-0.73-0.55-1.44-0.82-2.15 c-0.32-0.85-0.64-1.69-0.95-2.5l10.9,1.38L120.01,148.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M146.32,131.2c-4.84-1.04-9.89-2.49-9.89-2.49l-0.63-4.77C135.8,123.94,144.7,124.89,146.32,131.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M102.09,242.45c-0.41,0-0.81-0.18-1.09-0.52c-0.5-0.6-0.41-1.49,0.2-1.99 c15.71-12.9,15.41-33.12,15.12-52.68c-0.22-14.75-0.43-28.68,6.51-38.15c9.74-13.31,48.9-34.43,55.39-35.03 c4.64-0.46,146.24-39.82,220.47-60.56c0.75-0.21,1.53,0.23,1.74,0.98c0.21,0.75-0.23,1.53-0.98,1.74 c-8.78,2.45-215.15,60.11-220.97,60.65c-5.59,0.52-44.35,21.56-53.38,33.89c-6.38,8.71-6.18,22.18-5.96,36.44 c0.29,19.29,0.61,41.14-16.15,54.91C102.73,242.34,102.41,242.45,102.09,242.45z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M399.45,56.23c-1.48,0.41-8.57,2.39-19.36,5.41c-53.25,14.86-196.77,54.8-201.61,55.25 c-5.58,0.52-44.35,21.55-53.37,33.89c-6.38,8.71-6.18,22.19-5.96,36.44c0.28,19.29,0.61,41.15-16.16,54.91 c-0.26,0.22-0.57,0.32-0.89,0.32c-0.4,0-0.81-0.17-1.09-0.51c-0.5-0.6-0.4-1.5,0.2-2c15.72-12.9,15.41-33.12,15.12-52.68 c-0.23-14.75-0.43-28.68,6.51-38.16c9.74-13.32,48.9-34.44,55.39-35.04c4.37-0.43,129.82-35.26,206.49-56.65 c4.88-1.37,9.55-2.66,13.98-3.91c0.75-0.21,1.53,0.23,1.74,0.98C400.64,55.24,400.19,56.02,399.45,56.23z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M399.45,56.23c-1.48,0.41-8.57,2.39-19.36,5.41c1.25-1.53,2.87-2.95,4.61-4.22 c4.88-1.37,9.55-2.66,13.98-3.91c0.75-0.21,1.53,0.23,1.74,0.98C400.64,55.24,400.19,56.02,399.45,56.23z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M111.71,145.27l7.41-0.65c0,0,3.86-2.44,4.61-2.29c0.75,0.15,8.12,3.74,8.12,3.74s-3.35,4.3-3.9,5.2 c-0.55,0.9-7.22-3.33-7.22-3.33l-7.33,0.78L111.71,145.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M102.1,127.21c-3.36,2.41-12.12,21.98-11.2,25.01c0.93,3.03,28.19-2.94,28.19-2.94l-1.2-5.1h-14.67 l3.49-5.49c0,0,2.15-2.09,0.83-6.95C106.58,128.23,102.1,127.21,102.1,127.21z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__129_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M386.02,129.18l-5.58-2.64c0,0-2.79-5.41-3.65-6.27c-0.86-0.86-4.83,2.49-4.83,3.07 c0,0.58,2.9,6.05,3.65,6.37s3.38,0,3.38,0l5.31,2.57L386.02,129.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M399.06,95.69l1.12-4c0,0,1.77-5.22,1.58-6.43c-0.19-1.21-1.34-4.19-1.34-4.19s-4.9,5.96-4.9,6.7 c0,0.75,1.95,3.45,1.95,3.45l-0.92,4.47H399.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M403.36,125.88c0,0-4.21-5.25-5.46-10.12c-1.25-4.88,2.52-20.75,2.52-20.75l-3.97-1.06 c0,0-4.67,16.21-4.86,22.12c-0.19,5.92,8.63,23.26,8.63,23.26L403.36,125.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M400.81,136.39l-0.6,2.56c0,0-3.03-5.97-5.51-12.11c2.04,1.45,4.23,3.78,5.56,7.45 C400.51,134.98,400.69,135.69,400.81,136.39z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M425.7,137.34c-0.03,0.96-0.18,2.05-0.4,3.26c-0.43,2.35-1.17,5.13-2.01,8.19 c-0.45,1.61-0.9,3.33-1.37,5.15c-2.1,8.17-3.24,11.42-4.79,21.84l-29.8-7.07c0,0,2.08-12.8,7.33-26.13 c0.87-2.25,1.85-4.5,2.91-6.72c1.69-3.51,3.62-6.92,5.79-9.98c0,0,4.82,4.41,19.96,7.05 C425.16,133.24,425.79,134.83,425.7,137.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M421.95,133.97c-0.03,0.96,3.57,5.42,3.35,6.63c-0.4,0.27-0.88,0.57-1.43,0.9 c-10.08,5.87-23.31,2.89-29.21,1.07c0.87-2.25,2.79-6.38,3.85-8.6l7.07,1.57C405.58,135.54,417.15,132.91,421.95,133.97z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M409.82,127.3c1.08-0.41,9.97,1.8,9.31,1.99c-0.66,0.19-3.97,10.36-8.61,9.59 C405.89,138.12,405.96,128.77,409.82,127.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "369.58,293.93 363.99,295.14 360.72,282.27 366.33,281.06  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.59,292.81h6.96c0.23,0,0.44,0.16,0.49,0.39l1.13,5.1c0.1,0.46-0.2,0.9-0.65,1c-0.06,0.01-0.12,0.02-0.19,0.02 c-2.25-0.04-3.89-0.17-6.72-0.17c-1.74,0-6.99,0.18-9.4,0.18c-2.4,0-2.72-2.37-1.73-2.59c4.41-0.96,7.74-2.29,9.15-3.56 C361.89,292.93,362.24,292.8,362.59,292.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M360.7,293.81c-0.39,0.03-0.78-0.07-1.1-0.29c-0.21-0.18-0.32-0.45-0.28-0.73c0-0.16,0.09-0.31,0.23-0.38 c0.63-0.33,2.48,0.81,2.69,0.94c0.05,0.02,0.07,0.08,0.07,0.13c-0.01,0.06-0.05,0.1-0.1,0.12 C361.71,293.73,361.2,293.8,360.7,293.81z M359.85,292.62c-0.06-0.01-0.12,0.01-0.17,0.04c-0.04,0-0.08,0.05-0.09,0.16 c-0.02,0.18,0.04,0.37,0.18,0.49c0.64,0.29,1.37,0.33,2.04,0.1C361.21,293.02,360.54,292.76,359.85,292.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M362.16,293.61h-0.07c-0.59-0.32-1.73-1.58-1.62-2.19c0.04-0.21,0.22-0.36,0.44-0.36 c0.21-0.03,0.42,0.04,0.58,0.17c0.66,0.54,0.8,2.19,0.81,2.27c0,0.05-0.02,0.1-0.07,0.12 C362.21,293.63,362.18,293.62,362.16,293.61z M361.01,291.28h-0.07c-0.17,0-0.19,0.1-0.2,0.14c-0.07,0.37,0.66,1.33,1.25,1.77 c-0.04-0.65-0.27-1.28-0.68-1.79C361.23,291.32,361.12,291.28,361.01,291.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M417.37,176.21c0,0-4.83,23.03-16.13,29.22c-1.3,0.72-2.7,1.21-4.18,1.41c0,0-11.46,4.68-21.37,9.16 c-6.03,2.73-11.48,5.38-13.43,6.87c-5.16,3.93,7.48,65.23,7.48,65.23l-8.6,0.1c0,0-18.07-54.28-15.02-68.53 c3.05-14.25,35.43-36.06,35.43-36.06l5-13.72L417.37,176.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M401.24,205.43c-1.3,0.72-2.7,1.21-4.18,1.41c0,0-11.46,4.68-21.37,9.16c6.38-11.72,17.74-19.34,17.74-19.34 L401.24,205.43z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "441.58,293.93 435.99,295.14 432.72,282.27 438.33,281.06  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.59,292.81h6.96c0.23,0,0.44,0.16,0.49,0.39l1.13,5.1c0.1,0.46-0.2,0.9-0.65,1c-0.06,0.01-0.12,0.02-0.19,0.02 c-2.25-0.04-3.89-0.17-6.72-0.17c-1.74,0-6.99,0.18-9.4,0.18c-2.4,0-2.72-2.37-1.73-2.59c4.41-0.96,7.74-2.29,9.15-3.56 C433.89,292.93,434.24,292.8,434.59,292.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M432.7,293.81c-0.39,0.03-0.78-0.07-1.1-0.29c-0.21-0.18-0.32-0.45-0.28-0.73c0-0.16,0.09-0.31,0.23-0.38 c0.63-0.33,2.48,0.81,2.69,0.94c0.05,0.02,0.07,0.08,0.07,0.13c-0.01,0.06-0.05,0.1-0.1,0.12 C433.71,293.73,433.2,293.8,432.7,293.81z M431.84,292.62c-0.06-0.01-0.12,0.01-0.17,0.04c-0.04,0-0.08,0.05-0.09,0.16 c-0.02,0.18,0.05,0.37,0.18,0.49c0.64,0.29,1.37,0.33,2.04,0.1C433.21,293.02,432.54,292.76,431.84,292.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M434.16,293.61h-0.07c-0.59-0.32-1.73-1.58-1.62-2.19c0.04-0.21,0.22-0.36,0.44-0.36 c0.21-0.03,0.42,0.04,0.58,0.17c0.66,0.54,0.8,2.19,0.81,2.27c0,0.05-0.02,0.1-0.07,0.12 C434.21,293.63,434.18,293.62,434.16,293.61z M433.01,291.28h-0.07c-0.17,0-0.19,0.1-0.2,0.14c-0.07,0.37,0.66,1.33,1.25,1.77 c-0.04-0.65-0.27-1.28-0.68-1.79C433.23,291.32,433.12,291.28,433.01,291.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M419.3,132.18c-1.41,0.91-7.87,0.58-7.87,0.58l-3.05,3.28l-0.29-5.43c0,0-2.03-0.85-1.48-1.43 c1.84,0,3.07-0.5,3.9-1.31c1.31-1.28,1.57-3.34,1.55-5.39c0-0.02,0-0.05,0-0.07l0.01-0.01l5.53-2.83l3.82-1.96 C419.66,121.51,417.09,128.78,419.3,132.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M419.46,120.89c-1.83,4.62-6.61,6.68-8.94,6.98c1.31-1.28,1.57-3.34,1.55-5.39c0-0.03,0.01-0.06,0.01-0.08 l5.53-2.83C417.6,120.33,419.74,120.18,419.46,120.89z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M422.97,120.7c0,0,3.59,1.92,4.79-0.36c1.2-2.29-0.51-2.38,1.25-3.19c1.75-0.81,4.27-1.38,3.69-3.08 c-0.57-1.7-2.35-1.91-0.37-3.73c1.98-1.82,2.42-4.55-0.54-5.06c-2.96-0.51-1.83-2.79-1.98-3.8c-0.15-1.01-1.81-1.6-3.61-1.22 s-2.55-2.29-3.66-3.12c-1.11-0.83-2.65,0.19-3.05,1.32s-1.47-0.38-3.06-0.56c-1.59-0.18-1.21,1.48-1.7,3.03 c-0.5,1.55-1.46,0.54-2.59,1.82C411,104.02,410.9,112.76,422.97,120.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M424.53,115.33c-2.69,4.24-4.23,7.04-7.26,8.41c-0.39,0.18-0.81,0.34-1.27,0.47 c-5.9,1.73-10.75-3.94-9.2-9.56c0.26-0.94,0.64-1.94,1.13-2.96c2.1-4.42,6.17-8.94,11.01-8.35c4.26,0.49,7.31,4.33,6.82,8.59 C425.63,113.15,425.2,114.31,424.53,115.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M415.13,103.74c1.37,0.17,2.05,1.84,2.05,1.84s3.36,1.25,4.8,2.25c1.44,0.99,1.17,2.77,1.11,3.23 c-0.05,0.45-1.16,0.86-1.16,0.86s-2.04,4.8-2.59,6.13l0.28,4.43c0,0,5.42-3.03,8.64-9.72c3.21-6.69-10.19-12.57-10.19-12.57 L415.13,103.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M423.73,122.04c-1.25,0.68-2.73,0.84-4.1,0.44c-1.81-0.54-1.71-2.41-0.37-3.6 c1.21-1.04,3.62-2.07,5.03-0.86C425.7,119.23,425.26,121.18,423.73,122.04z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M419.14,129.29l-7.49,2.15l-3.23,4.37l0.88-5.35c0,0-0.81-1.24,0.52-3.16l-4.56,0.94l-2.75,4.6l5.35-1.26 l0.38,5.34l3.11-3.67l2.55,4.03l7.58-4.81L419.14,129.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M419.14,129.29l-7.49,2.15l-3.23,4.37l0.88-5.35c0,0-0.81-1.24,0.52-3.16l-4.56,0.94l-2.75,4.6l5.35-1.26 l0.38,5.34l3.11-3.67l2.55,4.03l7.58-4.81L419.14,129.29z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "387.72,165.24 386.55,169.89 417.36,176.21 417.82,171.04  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M401.47,167.67c-0.25-0.35-7.1-1.82-7.75-1.33c0,0-1.33,4.59-1.11,5.07c0.23,0.48,6.9,1.41,7.52,1.54 C400.76,173.08,401.72,168.02,401.47,167.67z M399.59,172.34c-0.51-0.1-5.99-0.87-6.18-1.27c-0.19-0.39,0.91-4.16,0.91-4.16 c0.53-0.4,6.16,0.81,6.37,1.09C400.89,168.29,400.1,172.45,399.59,172.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M399.85,169.24l-1.36-0.28c-0.26-0.05-0.51,0.1-0.59,0.35l-0.01,0.02c-0.09,0.29,0.1,0.59,0.39,0.64 l1.36,0.26c0.29,0.05,0.56-0.14,0.6-0.43C400.29,169.54,400.11,169.29,399.85,169.24z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M417.36,176.21c0,0,0.59,34.86-0.39,45.01c-0.98,10.15,24.38,65.83,24.38,65.83h-8.23 c0,0-24.9-40.75-30.61-53.3c-5.71-12.55-9.92-42.46-9.92-42.46L417.36,176.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M425.8,134.92c-1.27-2.88-20.79,1.39-22.56,0.89c-1.76-0.5-20.09-8.18-20.09-8.18l-1.59,4.11 c0,0,16.43,9.42,20.02,10.9c3.59,1.48,17.98,0.77,21.62-0.82C426.86,140.24,426.55,136.61,425.8,134.92z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M422.34,59.7l-5.91-37.69l-31.15,22.03l10.38,4.39c-10,22.92-42.44,90.07-98.26,139.58 c-71.31,63.26-171.07,94.37-172.07,94.68l5.52,18.01c4.24-1.3,104.6-32.56,179.04-98.59c59.32-52.62,92.68-122.03,103.15-146.32 L422.34,59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M416.69,53.11l-0.26-31.1l-31.15,22.03l10.38,4.39c-10,22.92-42.44,90.07-98.26,139.58 c-71.31,63.26-171.07,94.37-172.07,94.68l1.75,11.41c4.24-1.3,104.6-29.73,179.04-95.77c59.32-52.62,90.8-122.97,101.27-147.26 L416.69,53.11z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M411.25,61.3c-0.14,0-0.29-0.02-0.43-0.07l-18.09-5.85c-0.74-0.24-1.15-1.04-0.91-1.78 c0.24-0.74,1.04-1.15,1.78-0.91l18.09,5.85c0.74,0.24,1.15,1.04,0.91,1.78C412.4,60.92,411.85,61.3,411.25,61.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M411.25,61.3c-0.14,0-0.29-0.02-0.43-0.07l-18.09-5.85c-0.74-0.24-1.15-1.04-0.91-1.78 c0.24-0.74,1.04-1.15,1.78-0.91l18.09,5.85c0.74,0.24,1.15,1.04,0.91,1.78C412.4,60.92,411.85,61.3,411.25,61.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M194.6,237.58c-0.78,0-1.41-0.63-1.41-1.41c0-44.95,13.06-50.87,15.51-51.58l41.56-29.05 c0.03-0.02,0.06-0.04,0.09-0.06l159.5-94.6c0.67-0.4,1.54-0.18,1.94,0.49c0.4,0.67,0.18,1.54-0.49,1.94l-159.46,94.57 l-41.73,29.16c-0.17,0.12-0.37,0.2-0.58,0.24c-0.11,0.02-13.5,3.3-13.5,48.88C196.02,236.94,195.38,237.58,194.6,237.58z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M194.6,237.58c-0.78,0-1.41-0.63-1.41-1.41c0-44.95,13.06-50.87,15.51-51.58l41.56-29.05 c0.03-0.02,0.06-0.04,0.09-0.06l159.5-94.6c0.67-0.4,1.54-0.18,1.94,0.49c0.4,0.67,0.18,1.54-0.49,1.94l-159.46,94.57 l-41.73,29.16c-0.17,0.12-0.37,0.2-0.58,0.24c-0.11,0.02-13.5,3.3-13.5,48.88C196.02,236.94,195.38,237.58,194.6,237.58z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M205.45,190.93c0,0-7.26,4.68-12.78,6.13c-1.65,0.44-3.14,0.58-4.23,0.24c-4.11-1.3-1.67-9.25,0.78-14.27 c0.4-0.82,0.79-1.55,1.16-2.18l7.18,4.44c0,0-4.35,6.21-3.85,6.57c0.5,0.38,7.2-3.35,7.57-3.47 C201.65,188.26,205.45,190.93,205.45,190.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M205.45,190.93c0,0-7.26,4.68-12.78,6.13c-1.69-4.78-2.8-10.15-3.45-14.03c0.4-0.82,0.79-1.55,1.16-2.18 l7.18,4.44c0,0-4.35,6.21-3.85,6.57c0.5,0.38,7.2-3.35,7.57-3.47C201.65,188.26,205.45,190.93,205.45,190.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M240.83,163.6l4.25-3.8c0,0,0.91-2.66,1.37-3.04c0.46-0.38,8.21-0.99,8.21-0.99s0.15,4.1-0.46,5.17 c-0.61,1.06-6.94,1.52-6.94,1.52l-3.39,3.27L240.83,163.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M263.48,252.86c-1.21,17.48-4.46,42.28-4.46,42.28l-4.18,0.92c0,0-3.86-20.76-3.25-40.03 c0.14-4.34,0.51-8.61,1.19-12.53c0,0-14.48-5.57-24.54-10.55c-4.8-2.37-8.6-4.62-9.32-6.07c-2.24-4.47,7.95-14.98,7.95-14.98 c0.32,0.25,6.47,4.17,13.63,8.81c9.5,6.16,20.77,13.6,22.62,15.45C264.18,237.25,264.09,244.14,263.48,252.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M263.48,252.86c-4.41,1.61-8.54,2.58-11.89,3.17c0.14-4.34,0.51-8.61,1.19-12.53c0,0-14.48-5.57-24.54-10.55 l12.25-12.24c9.5,6.16,20.77,13.6,22.62,15.45C264.18,237.25,264.09,244.14,263.48,252.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M230.88,209c0,0,40.18,23.1,45.65,28.31c5.46,5.22,36.99,53.97,36.99,53.97l-2.65,2.53 c0,0-26.18-22.47-36.62-43.84l-43.36-20.93V209z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M200.36,166.35c0.06,0.04,0.14,0.08,0.21,0.11c0.95,0.5,2.04,0.95,3.21,1.05c3.28,0.29,5.38-0.45,6.6-2.08 c0.01,0,0.01,0,0.01,0c1.68-2.43,1.64-6.31,0.72-10.88c-0.42-2.09-0.98-3.89-1.76-5.23c-0.01-0.01-0.02-0.07-0.03-0.08 c-0.04-0.05-0.07-0.13-0.11-0.18c-1.15-1.87-2.77-2.96-5.15-3.19c-0.82-0.08-1.74-0.05-2.76,0.07 C192.3,147.1,192.76,162.19,200.36,166.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M200.56,166.46c0.95,0.5,2.02,0.82,3.19,0.92c3.27,0.29,5.37-0.55,6.58-2.21c-1.51,0.56-3.59,0.98-5.76,0.33 C203.2,165.1,201.82,165.6,200.56,166.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M199.96,173.82c-0.78,2.52,2.45,3.86,2.45,3.86c5.65-1.84,6.92-4.65,6.92-4.65 c-4.33-2.77-2.42-9.35-2.42-9.35l-0.96,0.37l-6.6,0.69c0,0,1.49,3.61,1.66,4.42c0,0.01,0.01,0.02,0.01,0.02 C201.86,173.42,199.96,173.82,199.96,173.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M209.33,149.26c0,0,1.37,6.22-4.21,9.76c0,0-1.65,6.89-5.4,7.51c-5.12,0.84-10.67-5.83-9.93-13.53 C190.74,143.02,205.26,140.19,209.33,149.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M207.88,156.79c-0.14-0.98-1.16-2.52-2.65-2.08c-1.55,0.45-1.88,4.47,2.12,4.79 C207.93,159.55,208.18,158.84,207.88,156.79z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M311.76,288.28l-4.33,3.34c-0.18,0.14-0.24,0.4-0.15,0.61l2.21,4.7c0.2,0.42,0.7,0.59,1.12,0.39 c0.06-0.03,0.11-0.06,0.16-0.1c1.75-1.4,1.81-1.61,4.04-3.33c1.37-1.06,5.62-4.1,7.52-5.56c1.89-1.46,0.7-3.52-0.21-3.1 c-4.06,1.92-7.49,2.89-9.37,2.75C312.39,287.95,312.04,288.06,311.76,288.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M312.71,288.2c-0.05,0.02-0.11,0.01-0.15-0.03c-0.04-0.04-0.05-0.09-0.03-0.14 c0.08-0.23,0.85-2.25,1.55-2.37c0.16-0.03,0.32,0.03,0.41,0.16c0.2,0.19,0.28,0.48,0.22,0.75c-0.12,0.37-0.36,0.69-0.69,0.9 C313.61,287.75,313.17,288,312.71,288.2z M312.9,287.81c0.66-0.23,1.22-0.7,1.55-1.32c0.03-0.18-0.02-0.37-0.15-0.5 c-0.07-0.08-0.14-0.1-0.17-0.07c-0.06,0.01-0.12,0.04-0.16,0.08C313.5,286.53,313.14,287.15,312.9,287.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M312.7,288.25c-0.05,0-0.1-0.02-0.13-0.06c-0.04-0.07-0.93-1.45-0.74-2.28c0.04-0.2,0.17-0.38,0.35-0.49 c0.17-0.13,0.4-0.12,0.56,0.02c0.46,0.41,0.32,2.09,0.05,2.7l-0.05,0.04C312.73,288.21,312.72,288.23,312.7,288.25z  M312.07,285.93c0,0.65,0.19,1.29,0.55,1.82c0.2-0.71,0.19-1.9-0.09-2.15c-0.03-0.02-0.1-0.1-0.24,0.01l-0.05,0.04 C312.15,285.73,312.09,285.82,312.07,285.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M259.76,292.32l-5.47,0.11c-0.23,0.01-0.43,0.17-0.48,0.4l-1.02,5.09c-0.09,0.46,0.21,0.9,0.67,0.98 c0.06,0.01,0.12,0.02,0.19,0.01c2.24-0.08,2.42-0.22,5.23-0.28c1.73-0.03,6.96,0.04,9.35-0.01c2.39-0.05,2.66-2.42,1.67-2.61 c-4.41-0.87-7.74-2.13-9.17-3.36C260.46,292.43,260.11,292.31,259.76,292.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M260.24,292.97c-0.05-0.01-0.1-0.06-0.1-0.11c-0.01-0.05,0.02-0.11,0.06-0.13c0.2-0.13,2.02-1.3,2.66-0.99 c0.15,0.07,0.24,0.21,0.24,0.37c0.04,0.27-0.06,0.55-0.27,0.73c-0.32,0.22-0.7,0.33-1.09,0.31 C261.23,293.14,260.73,293.08,260.24,292.97z M260.63,292.77c0.67,0.21,1.39,0.16,2.03-0.14c0.13-0.13,0.2-0.31,0.17-0.49 c-0.01-0.11-0.05-0.16-0.09-0.16c-0.05-0.03-0.11-0.04-0.17-0.03C261.87,292.1,261.21,292.38,260.63,292.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M260.2,293c-0.04-0.03-0.07-0.07-0.07-0.12c0.01-0.08,0.11-1.72,0.76-2.27c0.15-0.14,0.36-0.21,0.57-0.19 c0.21,0,0.4,0.14,0.44,0.35c0.13,0.6-0.98,1.88-1.57,2.21l-0.07,0C260.26,292.99,260.23,293,260.2,293z M261.07,290.76 c-0.39,0.52-0.61,1.15-0.64,1.8c0.58-0.45,1.28-1.42,1.2-1.79c-0.01-0.04-0.02-0.14-0.2-0.13l-0.07,0 C261.26,290.64,261.16,290.69,261.07,290.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M229.76,202.81l-19.93,8.37c-8.24-20.48-19.45-30.33-19.45-30.33c7.99-9.58,22.73-13.98,22.73-13.98 c2.05,1.58,3.9,3.76,5.57,6.25c1.63,2.47,3.07,5.25,4.33,8.09C227.61,191.58,229.76,202.81,229.76,202.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M209.14,153.77c0,0,6.27-6.39,0.26-10.59c-6.01-4.2-11.95,1.41-11.95,1.41s-14.25,3.58-11.12,13.05 c3.13,9.46,5.12,10.25,0.65,15.16c-4.47,4.91-9.03,12.17-4.36,16.73c4.67,4.56,20.77-0.33,25.61-7.33 C213.07,175.19,204.26,160.35,209.14,153.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M228.32,196.67l-21.64,7.43c0,0,4.78,23.59,8.26,27.53s26.71,22.21,29.99,20.78 c3.29-1.44,25.07-20.78,25.07-20.78l-36.88-25.29L228.32,196.67z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "225.16,201.11 229.76,199.58 228.63,197.3 224.26,198.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.39,203.37 206.68,205.03 207.3,207.03 211.92,205.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.91,205.17 224.23,201.42 223.39,199.14 212.29,203.05  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M223.01,181.21c-4.76-0.56-7.45-7.72-7.45-7.72c1.1-0.2,2.14-0.31,3.12-0.37 C220.31,175.59,221.75,178.36,223.01,181.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M213.11,166.86c5.18-0.77,16.77,3.43,17.77,3.38c1-0.05,12.28-8.88,12.28-8.88l2.92,2.57 c0,0-11.77,12.14-14.19,12.27c-2.42,0.13-15.09-0.81-15.09-0.81s-3.09-1.1-3.69-3.9C212.52,168.7,213.11,166.86,213.11,166.86z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img-1.e033a9b6828168f1bbc956c8c797159e.svg";
export { ForwardRef as ReactComponent };